// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/teams/v2/types.proto (package creativefabrica.teams.v2, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file creativefabrica/teams/v2/types.proto.
 */
export const file_creativefabrica_teams_v2_types: GenFile = /*@__PURE__*/
  fileDesc("CiRjcmVhdGl2ZWZhYnJpY2EvdGVhbXMvdjIvdHlwZXMucHJvdG8SGGNyZWF0aXZlZmFicmljYS50ZWFtcy52MireAQoQVGVhbUF2YXRhclN0YXR1cxIiCh5URUFNX0FWQVRBUl9TVEFUVVNfVU5TUEVDSUZJRUQQABIbChdURUFNX0FWQVRBUl9TVEFUVVNfTk9ORRABEiUKIVRFQU1fQVZBVEFSX1NUQVRVU19QRU5ESU5HX1VQTE9BRBACEiEKHVRFQU1fQVZBVEFSX1NUQVRVU19QUk9DRVNTSU5HEAMSIAocVEVBTV9BVkFUQVJfU1RBVFVTX0NPTVBMRVRFRBAEEh0KGVRFQU1fQVZBVEFSX1NUQVRVU19GQUlMRUQQBUJNWktnaXRodWIuY29tL2NyZWF0aXZlZmFicmljYS9zY2hlbWFzL3BrZy9nZW4vY3JlYXRpdmVmYWJyaWNhL3RlYW1zL3YyO3RlYW1zdjJiBnByb3RvMw");

/**
 * TeamAvatarStatus is where a team's avatar is in the upload pipeline. It is
 * computed from the team's state alongside the avatar URLs returned with it, so
 * the two cannot disagree: whenever the status is not COMPLETED, those URLs are
 * the previous avatar rather than the one being worked on.
 *
 * @generated from enum creativefabrica.teams.v2.TeamAvatarStatus
 */
export enum TeamAvatarStatus {
  /**
   * @generated from enum value: TEAM_AVATAR_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * No avatar and nothing on the way.
   *
   * @generated from enum value: TEAM_AVATAR_STATUS_NONE = 1;
   */
  NONE = 1,

  /**
   * An avatar has been requested but its upload has not landed yet. Any URLs
   * returned are the previous avatar, still being served.
   *
   * @generated from enum value: TEAM_AVATAR_STATUS_PENDING_UPLOAD = 2;
   */
  PENDING_UPLOAD = 2,

  /**
   * The upload has landed and is being cropped and converted. Any URLs returned
   * are still the previous avatar.
   *
   * @generated from enum value: TEAM_AVATAR_STATUS_PROCESSING = 3;
   */
  PROCESSING = 3,

  /**
   * The URLs returned are the current avatar and nothing is outstanding.
   *
   * @generated from enum value: TEAM_AVATAR_STATUS_COMPLETED = 4;
   */
  COMPLETED = 4,

  /**
   * The requested avatar will not happen: the upload was rejected at
   * validation, or processing it failed for good. Any URLs returned are the
   * previous avatar, which is untouched -- a failed change never replaces what
   * is already being served. Clears when a new avatar is requested.
   *
   * @generated from enum value: TEAM_AVATAR_STATUS_FAILED = 5;
   */
  FAILED = 5,
}

/**
 * TeamAvatarStatus is where a team's avatar is in the upload pipeline. It is
 * computed from the team's state alongside the avatar URLs returned with it, so
 * the two cannot disagree: whenever the status is not COMPLETED, those URLs are
 * the previous avatar rather than the one being worked on.
 *
 * @generated from enum creativefabrica.teams.v2.TeamAvatarStatus
 */
export type TeamAvatarStatusJson = "TEAM_AVATAR_STATUS_UNSPECIFIED" | "TEAM_AVATAR_STATUS_NONE" | "TEAM_AVATAR_STATUS_PENDING_UPLOAD" | "TEAM_AVATAR_STATUS_PROCESSING" | "TEAM_AVATAR_STATUS_COMPLETED" | "TEAM_AVATAR_STATUS_FAILED";

/**
 * Describes the enum creativefabrica.teams.v2.TeamAvatarStatus.
 */
export const TeamAvatarStatusSchema: GenEnum<TeamAvatarStatus, TeamAvatarStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_teams_v2_types, 0);

